import { FC } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import {
    buildStoreCustomerQuery,
    STORE_CUSTOMER_ACTIVE_TAB_ORDERS,
} from './storeCustomerTabs.constants';

/** Legacy menu path `/storeCustomerManagement` → canonical URL (ActiveTab only). */
export const StoreCustomerLegacyUrlRedirect: FC = () => {
    const location = useLocation();
    const activeTabParam = new URLSearchParams(location.search).get('ActiveTab');
    const activeTab = activeTabParam ?? STORE_CUSTOMER_ACTIVE_TAB_ORDERS;

    return <Redirect to={buildStoreCustomerQuery(activeTab)} />;
};
